import { EventHelper } from "app/helpers/eventHelper";
import { DangerZoneStates } from "../../../../utils/const";
import Team1 from "./components/Team1/Team1";
import Team2 from "./components/Team2/Team2";
export const EventNameSection = (
  props: Record<string, any>
): React.JSX.Element => {
  const { data, eventIncidents, DangerZoneTextOnly } = props;
  const { isHome, isAway, possibleVar, incidentType, dangerZoneState } =
    EventHelper.formatIncidentText(eventIncidents && eventIncidents[0]);
  const showDangerText =
    eventIncidents != null &&
    (incidentType != null ||
      possibleVar ||
      dangerZoneState !== DangerZoneStates.SAFE ||
      dangerZoneState !== DangerZoneStates.MISSED_INCIDENT);

  // eventIncidents are returned as a list
  // Find what the latest incident is by comparing to the eventPhase on the event
  const currentEventIncident = props?.eventIncidents?.find(eventIncident => {
    return data.eventPhase === eventIncident.eventPhase;
  });

  return (
    <div className="popular-event-cell__label__content__bottom">
      <div className="teams">
        <Team1
          data={data}
          eventIncidents={eventIncidents}
          DangerZoneTextOnly={DangerZoneTextOnly}
          isHome={isHome}
          isAway={isAway}
          possibleVar={possibleVar}
          incidentType={incidentType}
          dangerZoneState={dangerZoneState}
          showDangerText={showDangerText}
          teamBatting={currentEventIncident?.teamBatting}
          currentEventIncident={currentEventIncident || null}
        />
        <Team2
          data={data}
          eventIncidents={eventIncidents}
          DangerZoneTextOnly={DangerZoneTextOnly}
          isHome={isHome}
          isAway={isAway}
          possibleVar={possibleVar}
          incidentType={incidentType}
          dangerZoneState={dangerZoneState}
          showDangerText={showDangerText}
          teamBatting={currentEventIncident?.teamBatting}
          currentEventIncident={currentEventIncident || null}
        />
      </div>
    </div>
  );
};
